import { useSelector } from "react-redux";
import { useFormV3 } from "../context/FormV3Context/FormV3Context";
import { useMessageItem } from "../context/MessageItemContext/MessageItemContext";
import { isDataIdFromJava } from "./Scripts";

export const useCheckIfButtonDisabled = () => {
   const {
      formUuid,
      requiredLock,
      alertLock,
      isButtonClicked,
      isAnyRowEditing,
      isAnyFieldInFormLoading,
   } = useMessageItem();
   const { getFormV3Locks } = useFormV3();
   const { formInfo } = useSelector(({ formsv2 }) => formsv2);

   const checkIfDisabled = (button, recordId) => {
      const isFormV3 = recordId && isDataIdFromJava(recordId);
      const block_on_required = button?.restrictions?.blockades?.block_on_required_fields;
      const block_on_active_alert = button?.restrictions?.blockades?.block_on_active_alert;

      if (isFormV3) {
         const formV3Locks = isFormV3 && getFormV3Locks(recordId);
         const alertLockV3 = formV3Locks && formV3Locks?.alertLock;
         const requiredLockV3 = formV3Locks && formV3Locks?.requiredLock;

         if (block_on_required && requiredLockV3) return true;
         if (block_on_active_alert && alertLockV3) return true;
      } else {
         if (block_on_required && requiredLock) return true;
         if (block_on_active_alert && alertLock) return true;
      }
      // This function works only on specific filter. Unless backend gives us better response,
      // we will need to add logic for each filter
      try {
         if (isAnyRowEditing) return true;
         if (isAnyFieldInFormLoading) return true;

         // we are blocking button after user click action button. this is to prevent multiple clicking on action when step is execiuting
         if (isButtonClicked) return true;

         const filter = button?.restrictions?.filters?.[0];

         if (!filter) return false;

         if (formInfo[formUuid]?.mainFormRef) {
            const valueFromFilter = filter.filter.hideWhen.substring(
               filter.filter.hideWhen.lastIndexOf(" ") + 1,
            );
            const filterFieldTechname = filter.techname;
            const fieldValue = formInfo[formUuid].mainFormRef.getFieldValue(filterFieldTechname);
            if (fieldValue && fieldValue !== valueFromFilter) return false;
         }

         if (button?.restrictions?.active === "0") return true;

         return false;
      } catch {
         return false;
      }
   };

   return checkIfDisabled;
};
